export default function a07_FetchPostReplies (data) {
    console.log('FETCH_POST_REPLIES', data)
    return {
      type: 'FETCH_POST_REPLIES',
      payload: data
    };
  };